import * as R from 'ramda'

/**
 * This returns the dropdown options to be used in user filter dropdown
 * @param orgMembers
 * @param currentUserId
 * @param defaultStateItem
 * @returns {[*[]]|[...*[],(*),...*|(function(*): (*))]}
 */
export default (orgMembers, currentUserId, defaultStateItem) => {
  defaultStateItem = [defaultStateItem].filter(Boolean) // ignore if defaultStateItem is not provided
  if (orgMembers.length === 0) return [defaultStateItem]
  const [[_currentUser], remainingMembers] = R.partition(
    member => member.id === currentUserId,
    orgMembers.map(member => ({ id: member.userId, label: member.user.displayName }))
  )
  const currentUser = R.clone(_currentUser)
  currentUser.listLabel = `${currentUser.label} (you)`
  const members = R.sort((a, b) => {
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  }, remainingMembers)
  return [...defaultStateItem, currentUser, ...members]
}
